import { AbstractControl, FormControl, FormControlState } from '@angular/forms';

/**
 * Maps all properties of the form value interface passed, to FormControls
 * @example
 * interface SearchFormValue {
 *   input: string;
 *   type: OrgType;
 * }
 *
 * type SearchForm = ModelForm<SearchFormValue>;
 * // which will return a type equivalent to the following:
 * type SearchForm = {
 *   input: FormControl<string>;
 *   type: FormControl<OrgType>
 * }
 */
export type ModelForm<Type> = {
  [Property in keyof Type]: Type[Property] extends AbstractControl
    ? Type[Property]
    : FormControl<Type[Property]>;
};


/**
 * Maps all properties of the form value interface passed, to FormControls
 * @example
 * interface SearchFormValue {
 *   input: string;
 *   type: OrgType;
 * }
 *
 * type SearchForm = ModelForm<SearchFormValue>;
 * // which will return a type equivalent to the following:
 * type SearchForm = {
 *   input?: FormControl<string>;
 *   type?: FormControl<OrgType>
 * }
 */
export type ModelPartialForm<Type> = {
  [Property in keyof Type]?: Type[Property] extends AbstractControl
    ? Type[Property]
    : FormControl<Type[Property]>;
};

/**
 * The type of the raw value of the form
 */
export type ModelFormValue<Type> = {
  [Property in keyof Type]: Type[Property] extends FormControlState<infer X>
    ? X
    : Type[Property];
};